import {BaseValidatedClass} from './BaseValidatedClass';

interface ExternalVideosLibraryMap {
  openExternalVideosLibraryDialog(
    _currentValue: string,
    _successCallback: ExternalVideosLibrarySelectedCallback,
    _cancelCallback: ExternalVideosLibraryCancelCallback,
  ): void;
}

export type ExternalVideosLibrarySelectedCallback = (value: ExternalGalleryVideo) => void;
export type ExternalVideosLibraryCancelCallback = () => void;

// eslint-disable-next-line @typescript-eslint/consistent-type-definitions
export type ExternalGalleryVideo = {
  originalVideoName: string; // 'YOUR VIDEO NAME',
  originalImageName: string; //  'YOUR IMAGE NAME',
  urlImage: string; // 'https://YOUR_STORAGE_IMAGE_URL.png',
  urlVideo: string; // 'https://your_storage_url/YOUR_FILE',
  altText: string;
};
export class ExternalVideosLibrary extends BaseValidatedClass implements ExternalVideosLibraryMap {
  /** List of methods that must be implemented by subclasses */
  private static readonly REQUIRED_METHODS: (keyof ExternalVideosLibraryMap)[] = ['openExternalVideosLibraryDialog'];

  constructor() {
    super(ExternalVideosLibrary.REQUIRED_METHODS, ExternalVideosLibrary);
  }

  public openExternalVideosLibraryDialog(
    _currentValue: string,
    _successCallback: ExternalVideosLibrarySelectedCallback,
    _cancelCallback: ExternalVideosLibraryCancelCallback,
  ): void {
    throw new Error('Method openExternalVideosLibraryDialog() must be implemented by the subclass');
  }
}
